import { createSelector } from '@reduxjs/toolkit'

import { STATUS_NO_REVIEW_REQUIRED, STATUS_REVIEWED } from '../constants'

const pluckCapitalGainsTransactionId = (_state, { id }) => id

const getCapitalGainsSummary = (state) => state.capitalGainsSummary
export const getCapitalGainsTransactions = (state) => state.capitalGainsTransactions
export const getCapitalGainsTransactionsItems = (state) => state.capitalGainsTransactions.items

export const getCapitalGainsTransactionById = createSelector(
    [getCapitalGainsTransactionsItems, pluckCapitalGainsTransactionId],
    (capitalGainsTransactions, capitalGainsTransactionId) =>
        capitalGainsTransactions.find(
            (capitalGainsTransaction) => capitalGainsTransaction.id === capitalGainsTransactionId
        )
)

export const getAreAllCapitalGainsTransactionsReviewed = createSelector(
    [getCapitalGainsTransactionsItems],
    (capitalGainsTransactions) =>
        capitalGainsTransactions.every(({ reviewStatus }) =>
            [STATUS_NO_REVIEW_REQUIRED, STATUS_REVIEWED].includes(reviewStatus)
        )
)

export default createSelector(
    [getCapitalGainsSummary, getCapitalGainsTransactions],
    (capitalGainsSummary, capitalGainsTransactions) => ({
        capitalGainsSummary,
        capitalGainsSummaryStatus: capitalGainsSummary.status,
        capitalGainsTransactions,
        hasCapitalGainsSummary: !!capitalGainsSummary.taxReturnId,
    })
)
